import experience_graph from '../assets/experience_graph.png';

const Experience = ({ variant = 'classic' } = {}) => {
  if (variant === 'v2') {
    return (
      <section className="relative overflow-hidden bg-white py-20 sm:py-28">
        <div className="pointer-events-none absolute right-0 top-0 h-[380px] w-[380px] rounded-full bg-emerald-400/10 blur-[100px]" />
        <div className="relative mx-auto flex max-w-6xl flex-col items-center gap-12 px-4 sm:px-6 lg:flex-row lg:gap-16 lg:px-8">
          <div className="lg:w-1/2">
            <p className="text-xs font-bold tracking-[0.3em] text-[#6756FE] uppercase">
              Results
            </p>
            <p className="mt-3 text-sm font-semibold text-slate-600">
              Recommended by{' '}
              <span className="font-bold text-[#6756FE]">4000+</span> students
            </p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Experience the difference in your trading skills
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-600">
              After 6 months, you will be able to experience the difference in your knowledge and skills.
              You will be making informed trading decisions while effectively managing risk and maximizing profits.
            </p>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="mb-3 flex items-center justify-between">
              <span className="rounded-full bg-emerald-50 px-3 py-1 text-[11px] font-bold tracking-wide text-emerald-700 uppercase ring-1 ring-emerald-200/80">
                After 6 months
              </span>
            </div>
            <div className="relative overflow-hidden rounded-3xl border border-slate-200/80 bg-[#f8f7fc] p-4 shadow-xl shadow-slate-200/40">
              <p className="mb-4 text-center text-sm font-medium text-slate-700 sm:text-base">
                You will know effective methods for selecting{' '}
                <span className="font-semibold text-[#6756FE]">high-potential stock</span>
              </p>
              <img
                src={experience_graph}
                alt="Growth Chart"
                className="w-full rounded-2xl bg-white object-contain"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 px-4 md:px-20 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        <div className="lg:w-1/2">
          <div className="flex items-center mb-2">
            <span className="text-2xl mr-2">✨</span>
            <p className="font-semibold text-black">
              Recommended By <span className="text-indigo-600 font-bold">4000+ </span>Students
            </p>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-indigo-600 mb-4">
            Experience the difference in your trading skills
          </h2>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed">
            After 6 months, you will be able to experience the difference in your knowledge and skills.
            You will be making informed trading decisions while effectively managing risk and maximizing profits.
          </p>
        </div>
        <div>
          <p className="text-sm text-right text-indigo-600 font-semibold mb-2">AFTER 6 MONTHS</p>
          <div className=" w-full flex justify-center items-center relative">
            <img
              src={experience_graph}
              alt="Growth Chart"
              className="w-full bg-indigo-50 rounded-xl shadow-sm"
            />
            <div className="absolute top-6 left-6 text-white px-3 py-1 text-lg">
              <h3 className="text-gray-800 font-medium text-lg mb-6 text-center">
                You will know effective methods for selecting{' '}
                <span className="text-indigo-600 text-lg font-semibold">High-potential stock</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
